import * as React from "react";
const SvgDiscount = () => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.895 10.57a.67.67 0 0 1 0 .947l-9.378 9.377a.668.668 0 0 1-1.143-.474.67.67 0 0 1 .196-.473l9.377-9.377a.67.67 0 0 1 .948 0m-8.512 2.482a.67.67 0 1 0 0-1.339.67.67 0 0 0 0 1.34m0 1.34a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02m6.698 5.358a.67.67 0 1 0 0-1.339.67.67 0 0 0 0 1.34m0 1.34a2.01 2.01 0 1 0 0-4.02 2.01 2.01 0 0 0 0 4.02",
    clipRule: "evenodd"
  }
));
export default SvgDiscount;
